import React from 'react'
import { Header } from 'semantic-ui-react'
import styled from 'styled-components';
import { clearFix } from 'polished'

import { __ } from '~/i18n'

import Count from '../count'
import sizes from '~/components/sizes'


const ClearedHeader = styled(Header)`
  ${clearFix()}
  
  position: relative;
  
  .label {
    height: auto !important;
    position: static !important;
    top: auto !important;
    right: auto !important;
  }
`;

@sizes
export default class CartHeader extends React.PureComponent {
  render() {
    const { title, count, isTiny } = this.props;
    return (
      <ClearedHeader size='medium' textAlign={ isTiny ? 'center' : 'left' }>
        { title || __('Shopping Cart') }
        <Count count={ count } />
      </ClearedHeader>
    )
  }
}
